import { useMemo } from "react";

import { LeadPageTranslatedContent } from "../types";

type SearchPlaceHolderProps = {
  canViewPII: boolean;
  redactedFields: string[] | undefined;
  translatedContent: LeadPageTranslatedContent;
};

export function useSearchPlaceHolder({
  canViewPII,
  redactedFields,
  translatedContent,
}: SearchPlaceHolderProps) {
  return useMemo(() => {
    const redacted = redactedFields ?? [];

    if (canViewPII) {
      if (redacted.includes("name")) {
        return translatedContent.filterPIIEmailPlaceholder;
      }
      if (redacted.includes("email")) {
        return translatedContent.filterPIINamePlaceholder;
      }
      return translatedContent.filterPlaceholder;
    }

    return translatedContent.filterNoPIIPlaceholder;
  }, [canViewPII, redactedFields, translatedContent]);
}
